<template>
  <div>
    <div v-if="!photoList.length && !videoList.length" class="no-contract-type">暂无内容</div>
    <div class="photo-c c-flex">
      <div class="photo-c-item" v-for="(item, index) in photoList" :key="index">
        <el-image class="item-size" :src="item.url" fit="cover" :preview-src-list="photoPreviewList">
          <div slot="placeholder" class="image-slot">
            <div class="el-icon-loading"></div>
          </div>
        </el-image>
      </div>
    </div>
    <div class="video-c c-flex">
      <div class="video-c-item" v-for="(item, index) in videoList" :key="index">
        <video width="150" height="150" controls>
          <source :src="item.url" type="video/mp4" />
        </video>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      videoList: [],
      photoList: [],
      photoPreviewList: []
    }
  },
  methods: {
    getAttachment(attachment){
      if(attachment && attachment.length){
        this.photoList = attachment.filter(d=>d.type == 0)
        this.videoList = attachment.filter(d=>d.type == 1)
        this.photoPreviewList = this.photoList.map(d=>d.url)
      }
    }
  },
}
</script>

<style scoped lang='less'>
@import '~@/assets/form.less';
/deep/ .c-flex{
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 10px;
  .item-size{
    width: 150px;
    height: 150px;
    margin-right: 10px;
    margin-bottom: 10px;
  }
  .image-slot{
    height: inherit;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 36px;
    color: #999;
  }
}
</style>